import { gql } from 'graphql-tag';

export const getGenerateIntercomTokenQuery = gql`
  query GenerateIntercomTokenUrl($baseUrl: String!) {
    intercomTokenUrl(baseUrl: $baseUrl)
  }
`;

export const transportAnalyzerResultsQuery = gql`
  query TransportAnalyzerResults($first: Int, $cursor: String) {
    transportAnalyzerResults(first: $first, after: $cursor) {
      edges {
        cursor
        node {
          analyzeId
          companyId
          companyName
          companyType
          createdAt
          createdByUserId
          createdByUserName
          error
          finishedAt
          result
          debugLog {
            title
            duration
            logMessage
          }
          status
          tourId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
